// removed by extract-text-webpack-plugin
module.exports = {"loader":"ProgressBox__loader__jDomn","content":"ProgressBox__content__1MQNF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgressBox/ProgressBox.scss
// module id = 405
// module chunks = 0